import { Breadcrumbs, Link, Typography } from '@mui/joy';
import { ChevronRightRounded, HomeRounded } from '@mui/icons-material';
import { Link as RouterLink, useLocation } from 'react-router';
import { getRoutes } from '../constants';
import { matchPath } from 'react-router';
import { useDocumentTitleFromBreadcrumbs } from './useDocumentTitle';

const NavBreadcrumbs = ({ jobs = [], companies = [] }) => {
  const location = useLocation();
  const routes = getRoutes({ jobs, companies });

  // Find matching routes for current path
  const getBreadcrumbs = (pathname) => {
    const breadcrumbs = [];
    const pathSegments = pathname.split('/').filter(Boolean);

    // Build potential paths from segments
    for (let i = 1; i <= pathSegments.length; i++) {
      const currentPath = '/' + pathSegments.slice(0, i).join('/');
      
      // Find matching route configuration
      const matchingRoute = routes.find(route => {
        const match = matchPath(
          { path: route.path, exact: true },
          currentPath
        );
        return match;
      });

      if (matchingRoute) {
        const match = matchPath(
          { path: matchingRoute.path, exact: true },
          currentPath
        );

        let breadcrumbText = matchingRoute.breadcrumb;
        if (typeof breadcrumbText === 'function') {
          breadcrumbText = breadcrumbText({ match, pathname });
        }

        let url = currentPath;
        if (matchingRoute.url) {
          if (typeof matchingRoute.url === 'function') {
            url = matchingRoute.url({ match, pathname });
          } else if (matchingRoute.url === 'none') {
            url = null;
          } else {
            url = matchingRoute.url;
          }
        }

        breadcrumbs.push({
          breadcrumb: breadcrumbText,
          url: url,
          path: currentPath
        });
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs(location.pathname);

  // Auto-set document.title from the last breadcrumb
  useDocumentTitleFromBreadcrumbs(breadcrumbs);

  // Don't show breadcrumbs on home page or when none are available
  if (location.pathname === '/' || breadcrumbs.length === 0) {
    return null;
  }

  return (
    <Breadcrumbs
      size="sm"
      aria-label="breadcrumbs"
      separator={<ChevronRightRounded fontSize="sm" />}
      sx={{ pl: 0 }}
    >
      <Link
        underline="none"
        color="neutral"
        component={RouterLink}
        to="/dashboard"
        aria-label="Home"
      >
        <HomeRounded />
      </Link>
      {breadcrumbs.map(({ breadcrumb, url, path }, index) => {
        const isLast = index === breadcrumbs.length - 1;

        return isLast || url === null ? (
          <Typography color="primary" sx={{ fontWeight: 500, fontSize: 12 }} key={path}>
            {breadcrumb}
          </Typography>
        ) : (
          <Link
            underline="hover"
            color="neutral"
            component={RouterLink}
            to={url}
            key={path}
            sx={{ fontSize: 12, fontWeight: 500 }}
          >
            {breadcrumb}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default NavBreadcrumbs;